import React, { Component } from 'react';
import { connect } from 'react-redux';
import { filter, includes } from 'lodash';
import { message } from 'antd';
import SearchEventListModal from '../../../../views/widget/common/modal/SearchEventListModal';
import withModal from '../../../../lib/hoc/withModal';
import { widgetActions } from '../../../../store/modules/widget';
import { appActions } from '../../../../store/modules/app';
import { LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
import { comparePrePropsAndNextProps } from '../../../../lib/common';
import { EVENT_STATUS } from '../../../../constants/service/app/eventConstants';
import moment, { setDateFormat } from '../../../../lib/moment';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';

class SearchEventModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedEventList: [],
      selectedEventIdList: props.data.selectedId ? [props.data.selectedId] : [],
    };
  }

  componentDidMount = () => {
    this.initiate(this.props.data.selectedId);
  };

  componentDidUpdate(prevProps) {
    if (comparePrePropsAndNextProps([[prevProps.data.selectedItem, this.props.data.selectedItem]])) {
      this.setState({
        selectedEventList: [this.props.data.selectedItem],
      });
    }
  }

  initiate = (eventId) => {
    this.getList({
      eventId,
      pagination: LIST_PAGINATION_MODEL,
    });
  };

  /**
   * 기획전 선택하기
   */
  onSubmit = () => {
    const { selectedEventList } = this.state;
    const { setData, data } = this.props;
    const { targetPath } = data;
    const selectedEvent = selectedEventList[0];

    /**
     *  기획전이 선택되었는지 체크
     */
    if (!selectedEvent) {
      message.error('기획전을 선택해주세요.');
      return;
    }

    setData({
      path: [...targetPath, 'linkId'],
      value: selectedEvent.eventId,
    });

    setData({
      path: [...targetPath, 'linkName'],
      value: selectedEvent.mainTitle,
    });

    setData({
      path: [...targetPath, 'status'],
      value: selectedEvent.status,
    });

    setData({
      path: [...targetPath, 'url'],
      value: selectedEvent.url,
    });

    setData({
      path: [...targetPath, 'eventPeriod'],
      value: {
        startDate: selectedEvent.startDate,
        endDate: selectedEvent.endDate,
      },
    });

    /**
     *  기획전 노출기간 설정
     *
     *  기획전 기간: 무제한
     *  -> 기획전 노출기간: 현재 ~ 현재 + 7일
     *
     *  기획전 기간: 유한
     *  -> 기획전 노출기간: 기획전 기간
     */
    setData({
      path: [...targetPath, 'exposurePeriod'],
      value: {
        startDate:
          selectedEvent.status === EVENT_STATUS.unlimited
            ? setDateFormat(moment(), DATE_FORMAT.FULL_DASH_FORMAT)
            : selectedEvent.startDate,
        endDate:
          selectedEvent.status === EVENT_STATUS.unlimited
            ? setDateFormat(moment().add(7, 'day'), DATE_FORMAT.FULL_DASH_FORMAT)
            : selectedEvent.endDate,
      },
    });

    this.closeModal();
  };

  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({ name: 'searchEventListModal', value: false });
  };

  /**
   * 기획전 리스트 가져오기
   */
  getList = (option) => {
    const { getEventList, data } = this.props;
    const { listPath, listData } = data;
    const { filterOption, pagination } = listData;

    getEventList({
      filterOption,
      pagination,
      ...option,
      listPath,
    });
  };

  /**
   * 기획전 선택 callback
   */
  onCheckEvent = (list) => {
    const { selectedEventIdList } = this.state;
    const { data } = this.props;
    let targetIdList = list;

    if (list.length > 1) {
      targetIdList = filter(list, (id) => id !== selectedEventIdList[0]);
    }

    const targetList = filter(data.listData.list, (item) => includes(targetIdList, item.id));

    this.setState({
      selectedEventIdList: targetIdList,
      selectedEventList: targetList,
    });
  };

  render() {
    return (
      <SearchEventListModal
        {...this.state}
        {...this.props}
        onSubmit={this.onSubmit}
        closeModal={this.closeModal}
        getEventList={this.getList}
        onCheckEvent={this.onCheckEvent}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.widget.searchEventListModal.isOpen,
    data: state.widget.searchEventListModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: widgetActions.toggleModal,
  setData: widgetActions.setData,
  getEventList: widgetActions.getEventList,
  openEventItemListModal: appActions.openEventItemListModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(SearchEventModalContainer));
